var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46332 0.391878C5.53832 0.158532 5.75395 1.40626e-05 6.00004 0V9.52506L2.96955 11.8805C2.77502 12.0329 2.50549 12.0399 2.30322 11.8993C2.10119 11.7587 2.01424 11.5009 2.089 11.2665L3.28362 7.51646L0.217201 5.1305C0.0275196 4.98285 -0.0475043 4.73206 0.0304728 4.50472C0.108473 4.27737 0.322272 4.10393 0.562508 4.10393H4.27738L5.46332 0.391878Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfStar);
export default __webpack_public_path__ + "static/media/halfStar.d0c62d81cf1c1d698be2b86454bae43d.svg";
export { ForwardRef as ReactComponent };